const Loader = () => {
    return (
        <div className="fixed w-full h-full top-0 left-0 bg-white/50 z-99">

            <img src="/loader.gif" className="w-28 h-20 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" alt="loader" />

        </div>
    )
}
export default Loader;